module.exports = __webpack_public_path__ + "img/work.706d45b3.svg";